import { Component, Input } from '@angular/core';

import { simulacao } from '../../config-pedido-tipo-venda-indicador';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-badge-simulacao',
    templateUrl: './config-pedido-tipo-venda-badge-simulacao.component.html',
    styleUrls: ['./config-pedido-tipo-venda-badge-simulacao.component.less']
})
export class ConfigPedidoTipoVendaBadgeSimulacaoComponent {
    tipo = simulacao;

    /** Se o badge deve exibir o tipo de forma abreviada */
    @Input() isAbreviacao = false;
}
